module.exports = __webpack_public_path__ + "img/paytype-tips.3950178b.png";